var App = App || {};

App.StickyButtons = (function ($) {
    'use strict';

    function init() {
        var $stickyWrapper = $(".sticky-buttons-wrapper"),
            $topButton = $stickyWrapper.find(".top-button");
        var prioritizedIds = "#site-alerts #landing-header #site-header #site-main";

        setTopBtnHref($topButton, prioritizedIds);
        calculateZoom($stickyWrapper);

        if ($(".sharethis-sticky-share-buttons").length) {
            $stickyWrapper.addClass("higher")
        }

        $(document).ready(function () {
            var $chatBubble = $('.sticky-buttons-wrapper .chat-button');

            if (!$chatBubble) {
                return;
            }

            $chatBubble.click(function () {
                window.open(
                    'https://253278401.revation.com/widget/?rev-group=253278401&rev-brand=253278401&rev-dst-pid=SCFCU_LLAI@scfedreal.org',
                    'LiveChat',
                    'width=500,height=600,location=no,toolbar=no,menubar=no');
            });
        });

        $(document).scroll(function () {
            calculateZoom($stickyWrapper);
        });
    }

    function calculateZoom($stickyWrapper) {
        let zoom = ((window.outerWidth - 10) / window.innerWidth) * 100;
        if (zoom >= 300) {
            $stickyWrapper.addClass("zoomed");
        } else {
            $stickyWrapper.removeClass("zoomed");
        }
    }

    function setTopBtnHref(topButton, prioritizedIds) {
        var idArr = prioritizedIds.split(' ');
        for (var i = 0; i < idArr.length; i++){
            if ($(idArr[i]).length) {
                topButton.attr("href", idArr[i]);
                break;
            }
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.StickyButtons.init();
});